import "./ConsentForm.scss";
import { deepClone } from "src/legacy/utils/helpers";
import { Typography } from "src/latest/src/components";

interface Props {
    data: any;
    onChoiceSelection: (updatedAnswers: any) => void;
    answersObject: any;
    currentPage: number;
}

export const ConsentRadioGroup = ({
    data,
    onChoiceSelection,
    answersObject,
    currentPage,
}: Props) => {
    function handleRadioButtonClicked(
        answerUniqueKey: string,
        value: string
    ): void {
        const _answersObject = deepClone(answersObject);
        const el: any = document.getElementById(value);

        if (el) {
            el.checked = true;
            el.setAttribute("checked", "true");
        }

        if (_answersObject && answerUniqueKey && value) {
            _answersObject[currentPage][answerUniqueKey] = {
                error: undefined,
                answersData: [value],
            };

            if (onChoiceSelection) {
                onChoiceSelection(_answersObject);
            }
        }
    }

    return (
        <div style={{ marginBottom: "1rem" }}>
            <div
                style={{ paddingLeft: "2rem" }}
                className="consent-items-group"
            >
                <div style={{ marginBottom: "16px", fontWeight: "bold" }}>
                    <Typography variant='size-18' weight='bold' color='color-2'>{data?.display_title}</Typography>
                </div>
                {data?.choices.map((choice: any) => (
                    <div
                        key={choice.unique_key}
                        style={{
                            marginBottom: "1rem",
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            handleRadioButtonClicked(
                                data.unique_key,
                                choice?.unique_key
                            );
                        }}
                    >
                        <input
                            style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                            }}
                            type="radio"
                            id={choice?.unique_key}
                            name={data.unique_key}
                            value={choice?.unique_key}
                            onClick={() => {
                                handleRadioButtonClicked(
                                    data.unique_key,
                                    choice?.unique_key
                                );
                            }}
                        />
                        <label
                            className="prevent-select"
                            style={{ marginLeft: "1rem", cursor: "pointer" }}
                        >
                            {choice?.title}
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );
};
